var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIbgLogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 5.42871H3.23171C1.44688 5.42871 0 6.7079 0 8.28585V22.2859C0 23.8638 1.44688 25.143 3.23171 25.143H26.1768C27.9617 25.143 29.4085 23.8638 29.4085 22.2859V8.28585C29.4085 6.7079 27.9617 5.42871 26.1768 5.42871Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 27.7144H3.23171C1.44688 27.7144 0 28.9935 0 30.5715V44.5715C0 46.1495 1.44688 47.4286 3.23171 47.4286H26.1768C27.9617 47.4286 29.4085 46.1495 29.4085 44.5715V30.5715C29.4085 28.9935 27.9617 27.7144 26.1768 27.7144Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7683 9.71436H34.2561C32.4713 9.71436 31.0244 10.9935 31.0244 12.5715V23.1429C31.0244 24.7209 32.4713 26.0001 34.2561 26.0001H49.7683C51.5531 26.0001 53 24.7209 53 23.1429V12.5715C53 10.9935 51.5531 9.71436 49.7683 9.71436Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7683 27.1431H34.2561C32.4713 27.1431 31.0244 28.4223 31.0244 30.0002V40.5716C31.0244 42.1496 32.4713 43.4288 34.2561 43.4288H49.7683C51.5531 43.4288 53 42.1496 53 40.5716V30.0002C53 28.4223 51.5531 27.1431 49.7683 27.1431Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0919 42.2013C21.8884 42.1811 19.9662 41.6533 18.325 40.6185C16.684 39.5733 15.4101 38.1376 14.5035 36.3113C13.5969 34.4851 13.1436 32.3899 13.1436 30.0259C13.1436 27.6821 13.6198 25.6123 14.5723 23.8165C15.5363 22.0105 16.8618 20.5951 18.5488 19.5703C20.2359 18.5456 22.1753 18.0332 24.3673 18.0332C25.974 18.0332 27.3626 18.3071 28.5332 18.855C29.7038 19.3928 30.6964 20.1436 31.5113 21.1075C32.3375 22.0713 33.032 23.1773 33.5943 24.4252H35.1778L35.7977 29.9651L39.2404 41.7142H35.4535L32.217 29.9651C32.0449 29.2245 31.7809 28.3619 31.4252 27.3777C31.0694 26.3936 30.5932 25.4348 29.9964 24.5013C29.3996 23.5679 28.6365 22.7968 27.7069 22.188C26.7888 21.5691 25.6756 21.2597 24.3673 21.2597C22.9672 21.2597 21.7278 21.6351 20.649 22.3859C19.5702 23.1367 18.7267 24.1767 18.1185 25.5058C17.5102 26.8349 17.2061 28.3619 17.2061 30.0868C17.2061 31.7711 17.493 33.2879 18.0668 34.6373C18.6407 35.9765 19.444 37.0368 20.4768 37.8182C21.5097 38.5891 22.7147 38.9748 24.0919 38.9748C25.3657 38.9748 26.4732 38.6653 27.4142 38.0465C28.3553 37.4173 29.1472 36.6311 29.7898 35.6873C30.4325 34.7336 30.9489 33.7545 31.3391 32.7502C31.7408 31.7356 32.0334 30.8476 32.217 30.0868L35.109 18.3376H38.8962L35.7977 30.0868L35.1778 35.8091H33.8008C33.2039 37.0673 32.458 38.1833 31.5629 39.1573C30.6792 40.1213 29.6177 40.8722 28.3782 41.4099C27.1503 41.9476 25.7215 42.2113 24.0919 42.2013Z",
    fill: "url(#paint0_linear_806_1193)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_806_1193",
    x1: 26.3385,
    y1: -0.0000818097,
    x2: 26.3385,
    y2: 51.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.790625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbgLogowhite);
export default __webpack_public_path__ + "static/media/IBG Logo white.e7eb218a15e3d005ddcc482c8fc8d026.svg";
export { ForwardRef as ReactComponent };